import React, { useContext, useState } from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import Input from '../../forms/Input';
import NewSubjectModal from '../../NewSubjectModal';
import { EmptyCard, ToolBar } from '../../pageElements';
import { ButtonFilled, Icon, ScrollView } from '../../ui';
import { EditorContext } from '../EditorContext';
import SubjectsList from './SubjectsList';
import UngroupedSubjects from './UngroupedSubjects';

const SubjectPicker: React.FC = () => {
  const [filter, setFilter] = useState('');
  const [showNewSubjectModal, setShowNewSubjectModal] = useState(false);
  const { notebook } = useContext(NotebookContext);
  const { dispatch } = useContext(EditorContext);

  return (
    <div
      className="fixed absolute--fill flex flex-column bg-white z-max"
      data-testid="subject-picker"
    >
      <ScrollView className="flex flex-column ph2 ph3-m ph4-l">
        <ToolBar sticky={true}>
          <button onClick={() => dispatch({ type: 'closeSubjectPicker' })}>
            <Icon name="close" />
          </button>
        </ToolBar>

        {notebook.subjects.length === 0 && (
          <div className="flex-auto flex items-center h-100">
            <EmptyCard>
              <p className="serif mt0">You need to add a subject before you make an entry.</p>
              <ButtonFilled
                onClick={() => setShowNewSubjectModal(true)}
                data-testid="add-subject-button"
              >
                Add a Subject
              </ButtonFilled>
            </EmptyCard>
          </div>
        )}

        {notebook.subjects.length > 0 && (
          <div className="w-100 mw6-ns center pv2">
            <Input
              className="mb3 b--gray"
              placeholder="Search subjects..."
              value={filter}
              onChange={e => setFilter(e.target.value)}
              wrapperClassName="ph1"
            />

            <UngroupedSubjects />

            {notebook.groups
              .filter(group => group.subjects.length > 0)
              .map(group => {
                const groupSubjects = group.subjects.filter(subject =>
                  subject.name.toLowerCase().includes(filter.toLowerCase())
                );
                return (
                  <div key={group.id} data-testid={`group-${group.name}`}>
                    {groupSubjects.length > 0 && (
                      <>
                        <h1 className="ph1 db f6 fw5 ph1 mt4 mb3">{group.name}</h1>
                        <SubjectsList group={group} subjects={groupSubjects} />
                      </>
                    )}
                  </div>
                );
              })}
          </div>
        )}
      </ScrollView>
      {showNewSubjectModal && <NewSubjectModal closeModal={() => setShowNewSubjectModal(false)} />}
    </div>
  );
};

export default SubjectPicker;
